export default "__VITE_ASSET__d08c5bb3__"